<template>
  <section>
    <div class="title">我的消息({{totalRows}})</div>
    <div class="articleList">
      <div class="item container" v-for="msg in dataLst" :key="msg.msgId">
        <img :src="msg.msgJson.user.headImg || defaultHead"/>
        <div class="data">
          <div class="author">
            <router-link :to="{name: 'anotherHome',params: {userId:msg.msgJson.user.userId}}">
              <div class="name">{{msg.msgJson.user.userName}}</div>
            </router-link>
            <div v-if="msg.msgType==='EVAL'">评论了你的作品
              <router-link :to="{name: 'articleDetail',params: {articleId:msg.msgJson.articleId}}">
                <span>《{{msg.msgJson.articleTitle}}》</span>
              </router-link>
            </div>
            <div v-if="msg.msgType==='REPLY'">回复了你在
              <router-link :to="{name: 'articleDetail',params: {articleId:msg.msgJson.articleId}}">
                <span>《{{msg.msgJson.articleTitle}}》</span>
              </router-link>
              的评论
            </div>
            <div class="time">{{msg.createTime | formatTime}}</div>
          </div>
          <div class="content">{{msg.msgJson.content}}</div>
        </div>
        <div class="btn" @click="replyShowChange(msg.msgId)">回复</div>
        <div v-show="msg.msgId === replyShow" class="reply">
          <textarea v-model="msg.replyEval"></textarea>
          <div class="replySubmit" @click="replySubmit(msg)">回复</div>
        </div>
        <div class="parent" v-if="msg.msgType==='REPLY'">
          <div class="name">{{msg.msgJson.parentUserName}}:</div>
          <div>{{msg.msgJson.parentContent}}</div>
        </div>
      </div>
      <div class="noData" v-show="!dataLst || dataLst.length ===0">暂时没有消息~</div>
    </div>
    <laypage :pages="totalPages" @jump="updateDataPage" v-show="dataLst && totalRows > pageSize"
             :groups="totalPages>8?8:totalPages" skip="skip" class="layPage"></laypage>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </section>
</template>

<script>
import loading from '../common/loading.vue'
export default {
  name: 'userHome',
  data () {
    return {
      replyShow: -1,
      msg: '个人中心',
      defaultHead: require('../../assets/image/installer.png'),
      page: 1,
      pageSize: 6,
      totalPages: 10,
      totalRows: 0,
      dataLst: [],
      isLoad: true
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.getDataLst()
    this.isLoad = false
  },
  methods: {
    'replySubmit': function (reply) {
      if (!this.$root.checkLogin()) {
        this.$store.commit('setToastMsg', '请登录后操作')
        return ''
      }
      let that = this
      that.isLoad = true
      that.axios.post('/topic/eval', {
        userId: that.$store.state.user.userId,
        articleId: reply.msgJson.articleId,
        parentId: reply.msgJson.replyId,
        content: reply.replyEval
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status !== 0) {
          that.$store.commit('setToastMsg', response.data.msg)
        } else {
          reply.replyEval = ''
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
      this.replyShow = -1
    },
    'replyShowChange': function (index) {
      if (this.replyShow === index) {
        this.replyShow = -1
      } else {
        this.replyShow = index
      }
    },
    'updateDataPage': function (p) {
      this.page = p
      this.getDataLst()
    },
    'getDataLst': function () {
      this.isLoad = true
      let that = this
      that.axios.post('user/msgList', {
        userId: that.$root.getUserId(),
        page: that.page,
        pageSize: that.pageSize
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          var res = response.data.value
          that.dataLst = res.dataLst
          for (let j = 0, len = that.dataLst.length; j < len; j++) {
            that.dataLst[j].msgJson = JSON.parse(that.dataLst[j].msgJson)
          }
          that.totalPages = res.totalPages
          that.totalRows = res.totalRows
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {},
  components: {
    loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  padding-left: 30px;
  background-color: #FFFFFF;
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
}
.articleList {
  width: 980px;
}
.articleList .item {
  width: 950px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #F0F0F0;
}
.articleList .item img {
  padding: 25px 25px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  float: left;
}
.articleList .item .data {
  padding-top: 15px;
  width: 650px;
  float: left;
}
.data .author, .data .content {
  width: 650px;
  height: 40px;
  line-height: 40px;
  overflow:hidden;
  text-overflow:ellipsis;
}
.data .author div {
  float: left;
  padding-right: 20px;
}
.data .author div span{
  color: #0AB878;
}
.data .author .name {
  font-weight: 600;
}
.data .author .time {
  font-size: 12px;
}
.articleList .item .btn {
  float: right;
  margin-right: 20px;
  margin-top: 35px;
  width: 100px;
  text-align: center;
  line-height: 30px;
  height: 30px;
  color: #333333;
  cursor: pointer;
}
.item .parent,.item .reply {
  width: 830px;
  height: 80px;
  background-color: #F0F0F0;
  float: right;
  line-height: 25px;
  margin-right: 15px;
  margin-bottom: 15px;
}
.item .reply {
  background-color: #FFFFFF;
}
.item .reply textarea {
  background-color: #F0F0F0;
  width: 810px;
  padding: 10px;
}
.item .reply .replySubmit {
  float: right;
  width: 100px;
  text-align: center;
  line-height: 30px;
  background-color: #0AB878;
  color: #FFFFFF;
  border-radius: 2px;
}
.item .parent div {
  margin-left: 15px;
}
.item .parent .name {
  margin-top: 15px;
  font-weight: 600;
}
.articleList .noData {
  width: 950px;
  margin-top: 20px;
  background-color: #FFFFFF;
  text-align: center;
  line-height: 100px;
  color: #A0A0A0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userMsg.vue